import { FileText } from 'lucide-react';

import type { Research } from '@/api/types';
import { type DocSection, DocumentSections } from '@/ui/DocumentSections';
import { Markdown } from '@/ui/Markdown';

import { AssetsConsulted } from './AssetsConsulted';
import { RECOMMENDATION_KEY, withoutLeadTitle } from './reportText';

const ASSET_LEVERAGE_KEY = 'gft_asset_leverage';

/** The report's sections, but the recommendation: that one is a tile beside the verdict. */
function reportSections(research: Research): DocSection[] {
  return research.report.filter((section) => section.key !== RECOMMENDATION_KEY).map((section) => ({
    id: `report-${section.key}`,
    title: section.title,
    body: (
      <>
        {section.markdown ? (
          <div className="doc-sections-prose">
            <Markdown headingLevel={3}>{withoutLeadTitle(section.markdown, section.title)}</Markdown>
          </div>
        ) : (
          <p className="hint">Nothing was written for this section.</p>
        )}
        {section.key === ASSET_LEVERAGE_KEY && (
          <AssetsConsulted used={research.assets_used ?? null} evaluated={research.assets_evaluated} />
        )}
      </>
    ),
  }));
}

/** The content card: the research report with its sticky section index. */
export function IdeaReportCard({ research }: { research: Research }) {
  return (
    <div className="card list-card idea-card section-gap">
      <div className="tabs card-tabs" role="tablist" aria-label="Idea details">
        <button type="button" role="tab" aria-selected="true" className="tab is-active">
          <FileText aria-hidden="true" />
          Report
        </button>
      </div>
      <DocumentSections sections={reportSections(research)} />
    </div>
  );
}
